import React from "react";
import { useSelector } from "react-redux";

import FundedCustomerData from "./FundedCustomerData";
import CustomerData from "./CustomerData";
import AccountData from "./AccountData";

export const AccountStandardData = ({ accountId }) => {
    const isDyl = useSelector(state => state.auth.dyl_employee);
    const { customer_status, fund_type } = useSelector(
        (state) => state.account.account?.customer || {}
    );

    if (customer_status) {
        if (fund_type && fund_type !== "unfunded" && isDyl) {
            return (
                <FundedCustomerData accountId={accountId} />
            )
        }
        return (
            <>
                <CustomerData />
            </>
        );
    }
    return <AccountData />;
};
